<script setup lang="ts">

import { LINKS } from '@presentation/Types/Settings';

</script>

<template>

    <Page>
    
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 xl:gap-10 2xl:gap-12">
        
            <!-- CONSUMER -->
            <div class="justify-self-end w-[60vw] md:max-w-[300px] flex items-center">
                <a :href="LINKS.ConsumerDemo"
                    target="_blank"
                    class="block transition-transform duration-300 ease hover:-translate-y-4 max-w-[50%]">
                    <Image src="/Demo/carbucks.png" class="2xl:scale-110" />
                </a>
                <div class="w-[90%] h-8 absolute -bottom-16 2xl:-bottom-20 transition-all duration-500 ease max-w-[50%]"
                    style="background-image: radial-gradient( ellipse farthest-side at center, rgba( 0,0,0, 0.2 ) 0%, transparent 100%);" 
                />
            </div>
        
            <!-- DEALER -->
            <div class="justify-self-center w-[60vw] md:max-w-[500px] md:scale-125 flex items-center">
                <a :href="LINKS.CarparcDemo"
                    target="_blank"
                    class="transition-transform duration-300 ease hover:-translate-y-4 max-w-[60%]
                     2xl:left-16 3xl:left-24">
                    <Image src="/Demo/carparc.png" class="2xl:scale-110" />
                </a>
                <div class="w-[90%] h-8 absolute -bottom-10 2xl:-bottom-14 transition-all duration-500 ease"
                    style="background-image: radial-gradient( ellipse farthest-side at center, rgba( 0,0,0, 0.2 ) 0%, transparent 100%);" 
                />
            </div>

        </div>

    </Page>

</template>